import { SessionProviderConfig, createSessionProvider } from '../../../app';

export function configureSessionProvider(config: SessionProviderConfig) {
    return createSessionProvider({
        ...config,
    });
}
